module.exports = __webpack_public_path__ + "img/dropsBanner_460.bb0045df.png";